import countries from "../assets/countryCode.json";

export interface NormalizedPhone {
  phoneNumber: string;
  countryCode: string;
  country: string;
}

export const normalizePhoneNumber = (rawValue: string): NormalizedPhone => {
  if (!rawValue) return { phoneNumber: "", countryCode: "", country: "" };

  // Remove spaces, dashes, parentheses
  let digits = String(rawValue).replace(/[\s\-()]/g, "");

  // Initialize
  let countryCode = "";
  let country = "";

  // Check for + prefix
  if (digits.startsWith("+")) {
    const match = digits.match(/^\+(\d{1,3})(\d+)/);
    if (match) {
      countryCode = `+${match[1]}`;
      digits = match[2];
    }
  } else {
    // Match known country codes
    for (const c of countries) {
      if (digits.startsWith(c.countryCode)) {
        countryCode = `+${c.countryCode}`;
        digits = digits.slice(c.countryCode.length);
        break;
      }
    }
  }

  // Special handling for Malaysia
  if (!countryCode && digits.startsWith("0")) {
    countryCode = "+60";
    digits = digits.slice(1);
  }

  // Lookup country name from JSON
  if (countryCode) {
    const lookupCode = countryCode.replace("+", "");
    const found = countries.find((c) => c.countryCode === lookupCode);
    if (found) country = found.countryName || found.countryCode;
  }

  return { phoneNumber: digits, countryCode, country };
};
